import { put, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { PurchaseCouponActionTypes } from './types';
import PurchaseCouponRequest from '../../models/coupon/PurchaseCouponRequest';
import { purchaseCouponActions } from './actions';
import OrderService from '../../services/order.service';
import RedirectRequest from "../../models/order/RedirectRequest";
import CorvusUtility from '../../blocks/utils/corvus-utility';
import OrderResponse from '../../models/order/OrderResponse';
import Toast from '../../components/shared/Toast';
import { ResponseCode } from '../../models/order/ResponseCode';
import { push } from 'connected-react-router';
import RoutesConst from '../../blocks/consts/RoutesConst';
import { OrderType } from '../../models/order/OrderType';

export default function* couponSaga() {
    yield takeEvery(PurchaseCouponActionTypes.REQUEST, purchaseCouponRequest);
    yield takeEvery(PurchaseCouponActionTypes.SUCCESS, purchaseCouponSuccess);
    yield takeEvery(PurchaseCouponActionTypes.ERROR, purchaseCouponError);
}

function* purchaseCouponRequest(action: Action<PurchaseCouponRequest>) {
    const purchaseCouponRequest = action.payload;
    const redirectRequest = { couponHash: purchaseCouponRequest.couponHash, installments: purchaseCouponRequest.installments } as RedirectRequest;

    yield sagaUtility(redirectRequest, OrderService.redirect, purchaseCouponActions.success, purchaseCouponActions.failure);
}

function* purchaseCouponSuccess(action: Action<any>) {
    const orderResponse = action.payload as OrderResponse;

    if (orderResponse?.ResponseCode === ResponseCode.Error) {
        Toast.notifyError(orderResponse.ResponseMessage);
    }
    else if (orderResponse?.IsMoneyLessOrder) {
        yield put(push(`${RoutesConst.PaymentInfo}?responseCode=${orderResponse.ResponseCode}&orderType=${OrderType.Coupon}`));
    }
    else {
        CorvusUtility.redirectToPaymentForm(action.payload);
    }
}

function* purchaseCouponError(action: Action<OrderResponse>) {
    Toast.notifyError(action.payload.ResponseMessage);
}
